import { useTranslation } from 'react-i18next';
import { Method } from '../api/methodsApi';
import Tooltip from '@pelckmans/elementis/components/tooltip';
import Pill from '@pelckmans/elementis/components/pill';

function MethodStatus({ method, role }: { method: Method; role: string }) {
  const { t } = useTranslation();
  const { id, published } = method;

  const BASE = 'PAGES.CATALOGUE.METHOD.STATUS';

  return (
    <>
      {!published && (
        <Tooltip
          key={`review-${id}`}
          truncation="wrapped"
          anchor={
            <Pill tooltip prominence="info" role="status">
              {t(`${BASE}.REVIEW.LABEL`)}
            </Pill>
          }
        >
          {t(`${BASE}.REVIEW.TOOLTIP.VALUE`, { role })}
        </Tooltip>
      )}
    </>
  );
}

export default MethodStatus;
